export enum ContentLincolnCenterStates {
  NONE = 0,
  CALIBRATION = 1,
  CONTENT = 2
}

// interface for a specific state 
export type ContentLincolnCenterState = number;